import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';

const Layout: React.FC = () => {
  console.log('Layout component rendering...');
  
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-green-100 p-4 text-green-800">
        Layout component is rendering! ✅
      </div>
      <Header />
      <div className="flex">
        <Sidebar />
        <main className="flex-1 p-6">
          <div className="bg-blue-100 p-4 text-blue-800 mb-4">
            Main content area is rendering! ✅
          </div>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout; 